import React, { useState } from 'react';
import questionMark from '../assests/questionsvg.svg';
import ModalBox from './help/modalBox';
import { payme_adhar_description, payme_adhar_list, payme_pan_description, payme_pan_list } from './help/modalConstant';

const Header = ({heading, questionState=true}) => {
  const [modalState, setModalState] = useState(false);
  const link = window.location.pathname
//   mixpanel.init("a2d443c0325cd9901372e3d0492e417b",{
//     debug:true
// })
  const fnCheck = () =>{
    if(link === '/'){
      return payme_pan_list
    }
    else{
      return payme_adhar_list
    }
  }
  const headCheck = () =>{
    if(link === '/'){
      return payme_pan_description
    }
    else{
      return payme_adhar_description
    }
  }
  return (
    <>
        <div className="header">
          <div className="head-container">
            <div className="heading-sc">
              <div className={(link === '/adharnumber' || link === '/password' || link === '/otp-verify') ? "heading  headerDiv2":" heading  headerDiv justify-content-start"} >
                <h1>{heading}</h1>
                {link !== '/'&& questionState && <img data-testid="crossButtonID1" className={link === '/adharnumber' || link === '/password' ? "adharHead":""} onClick={()=>{setModalState(true)}} src={questionMark} />}
              </div>
            </div>
          </div>
        </div>
        {modalState  && <ModalBox open={modalState}   List={fnCheck()} heading={headCheck()} onChange={(props)=>{setModalState(props)}}  imagesVisible={false} />}
    </>
  )
}

export default Header